import { AlertTriangle, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

// "Update CRM?" prompt shown when leaving/generating a PDF for an already-in-CRM
// Recent Quote that's been edited — Yes replicates Zoho's native "Revise Quote"
// (original → Closed Revised + new quote created), No just continues as normal.
export default function CrmRevisePromptModal({ onYes, onNo, revising }) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4" data-testid="crm-revise-prompt-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
        <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-3">
          <AlertTriangle className="w-6 h-6" style={{ color: '#ee7203' }} />
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-1">Update CRM?</h3>
        <p className="text-sm text-gray-500 mb-5">
          You've edited a quote that's already in CRM. Revise it in Zoho — the
          original will be marked <span className="font-semibold">Closed Revised</span> and
          a new quote created with your latest edits.
        </p>
        <div className="flex gap-3">
          <Button
            variant="outline"
            disabled={revising}
            onClick={onNo}
            className="flex-1 rounded-xl h-11 font-semibold"
            data-testid="crm-revise-prompt-no"
          >
            No, continue
          </Button>
          <Button
            disabled={revising}
            onClick={onYes}
            className="flex-1 rounded-xl h-11 font-semibold text-white"
            style={{ background: '#ee7203' }}
            data-testid="crm-revise-prompt-yes"
          >
            {revising ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Yes, revise
          </Button>
        </div>
      </div>
    </div>
  );
}
